import angular from 'angular';

import '../../vendor/chosen/chosen.min';

export function CoreLiteCtrl (
  $filter,
  $rootScope,
  $scope,
  $state,
  $transitions,
  $translate,
  $uibModalStack,
  $urlService,
  chargifyApi,
  companyApi,
  confirm,
  deviceDetector,
  sessionObjAPI
) {

  $scope.date  = new Date();
  $scope.today = $filter('date')($scope.date, 'yyyy-MM-dd');
  $scope.user  = sessionObjAPI.base().username;

  $rootScope.beta        = $urlService.config.host().indexOf('beta') >= 0;
  $rootScope.chargifyApi = chargifyApi;
  $rootScope.company     = sessionObjAPI.company();
  $rootScope.deviceData  = deviceDetector;
  $rootScope.sessionApi  = sessionObjAPI;
  $rootScope.sidebarOpen = true;

  $rootScope.Company = companyApi;

  $rootScope.pluralize = function ( value = '' ) {
    return $filter('pluralize')(value);
  };

  $scope.checkRights = function ( controller ) {
    const rights = sessionObjAPI.getRights();

    return ( rights.indexOf(controller) > -1 );
  };

  $scope.companyInfo = function() {
    if (!sessionObjAPI.base()) {
      return false;
    }

    return sessionObjAPI.base().company_settings;
  };

  // Checks what page is loaded and highlights the right item in the sidebar
  $scope.isActive = function (viewLocation) {
    return ($urlService.path().indexOf(viewLocation) >= 0);
  };

  $scope.isBeta = function () {
    return $rootScope.beta
      && !sessionObjAPI.base().demo_user;
  };

  $scope.isBoschPuppet = function() {
    if (!sessionObjAPI.base()) {
      return false;
    }
    else if (sessionObjAPI.base().puppet_session && sessionObjAPI.company().branding_group == 'bosch' && !sessionObjAPI.dealer_superuser()) {
      return true;
    }
    else {
      return false;
    };
  };

  $scope.navigateTo = function ( state = 'app' ) {
    $state.go(state);
  };

  $transitions.onStart({}, transition => {
    /**
     * When the route changes to a different view,
     * make sure all modals have been dismissed.
     */
    if (transition.from().name !== transition.to().name) {
      $uibModalStack.dismissAll();
    }

    // There are a lot of mousedown events dealing with the search boxes
    // so everytime the view changes, the watches need to be reset
    $(document).off('mousedown');
  });

  // Before the location changes, check if there is a form
  // if there is then check if it is pristine. If it is, then
  // carry on normally. If the form has been touched, stop
  // navigation and show a pop up warning
  $transitions.onStart({}, transition => {
    if (angular.element('#form').length) {
      const form = angular.element('#form').scope().form;

      if ( form && transition.from().name === transition.to().name ) {
        form.$setPristine();
      }

      if (!$rootScope.changeToRoute && form && !form.$pristine) {
        confirm
          .generic($translate.instant('JS_SPACE.CONFIRM.UNSAVED_DATA'))
          .then(() => {
            $state.go(transition.to().name, transition.params(), {
              inherit: false
            });

            form.$setPristine();

            $rootScope.changeToRoute = true;
          })
          .catch(() => $rootScope.changeToRoute = false);

        return false;
      }
    }
  });

  $transitions.onSuccess({}, () => {
    $rootScope.changeToRoute = false;
  });
}